import { Delete, Filter1Rounded, Search, Sort } from "@mui/icons-material";
import {
  AppBar,
  Box,
  Tab,
  Button,
  FormControl,
  FilledInput,
  InputAdornment,
  ButtonGroup,
  Collapse,
  InputLabel,
  MenuItem,
  Select,
  Tabs,
  Paper,
  Grid,
  Badge,
  IconButton,
  Popover,
  MenuList,
  ListItemText,
  ListItemIcon,
  TextField,
  Snackbar,
  Alert,
  CircularProgress,
} from "@mui/material";
import ScopeHeader from "components/ScopeHeader";

import i18n from "i18n/i18n";
import React, { useEffect, useState } from "react";
import { useBoundStore } from "store/store";
import { ReactComponent as Filter } from "assets/Svgs/FilterSvg.svg";

import { ReactComponent as TableMode } from "assets/Svgs/TableViewSvg.svg";
import { ReactComponent as TileMode } from "assets/Svgs/TileViewSvg.svg";

import UsersTable from "./UsersTable";
import { ReactComponent as InfoCircle } from "assets/Svgs/CheckCircle.svg";
import ErrorIcon from "@mui/icons-material/Error";
import { ReactComponent as EllipseSvg } from "assets/Svgs/EllipseSvg.svg";
import { ReactComponent as EllipseGraySvg } from "assets/Svgs/EllipseGraySvg.svg";
import { ReactComponent as CloseSvg } from "assets/Svgs/CloseSvg.svg";
import { Link, useNavigate } from "react-router-dom";
import TabPanel from "components/TabPanel";
import { saveAs } from "file-saver";

function Users() {
  const t: any[] = [];
  const [_users, set_users] = useState(t);

  const [alertType, setAlertType] = useState("");
  const [alertText, setAlertText] = useState("");

  const [requestType, setRequestType] = useState("");

  const navigate = useNavigate();

  const getAllUsers = useBoundStore((store) => store.getAllUsers);
  const getAllAclUsers = useBoundStore((store) => store.getAllAclUsers);

  const profiles: any = useBoundStore((store) => store.profiles);
  const lang: any = useBoundStore((store) => store.lang);

  const legalEntityNodeId = useBoundStore((store) => store.legalEntityNodeId);

  const clientInfoObj: any = useBoundStore((store) => store.clientInfoObj);
  const updateEmailConfig = useBoundStore((store) => store.updateEmailConfig);
  const testSMTP = useBoundStore((store) => store.testSMTP);
  const clientId = useBoundStore((store) => store.clientId);

  const getNetConnectConfiguration = useBoundStore(
    (store) => store.getNetConnectConfiguration
  );

  const [host, setHost]: any = useState("");
  const [port, setPort] = useState("");
  const [from, setFrom] = useState("");
  const [username, setUserName] = useState("");
  const [password, setPassword] = useState("");

  var users: any[] = useBoundStore((store) => store.users);

  const [data, setData] = useState(users);

  useEffect(() => {
    if (clientInfoObj&&clientInfoObj.autoemailconfig != undefined) {
      setHost(clientInfoObj?.autoemailconfig.host);
      setPort(clientInfoObj?.autoemailconfig.port);
      setFrom(clientInfoObj?.autoemailconfig.from);
      setUserName(clientInfoObj?.autoemailconfig.username);
      setPassword(clientInfoObj?.autoemailconfig.password);
    }

    let lc: any = localStorage.getItem("local-storage");
    lc = JSON.parse(lc);
    getAllAclUsers();
    getAllUsers(legalEntityNodeId, lc.state.user.nodeid);
  }, []);

  const [statusValue, setStatusValue] = useState("");

  const [loader, setLoader] = useState(false);

  const [appBarValue, setAppBarValue] = React.useState(0);
  const [userStatus, setuserStatus] = React.useState("alle");
  const [userType, setuserType] = React.useState("");
  const isAuthUser = useBoundStore((state) => state.isAuthUser);
  const [showFilter, setShowFilter] = useState(false);
  const smtpResponse = useBoundStore((state) => state.smtpResponse);

  function a11yProps(index: number) {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`,
    };
  }

  const handleAppBarChange = (
    event: React.SyntheticEvent,
    newValue: number
  ) => {
    setAppBarValue(newValue);
  };

  const [viewMode, setViewMode] = useState("table");

  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(0);

  let searchEnabled = searchText.length;

  const handleSearch = (e: any) => {
    let text = e.target.value.toLowerCase();
    setSearchText(text);
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage - 1);
  };

  const handleStatusChange = (event: any) => {
    setuserStatus(event.target.value);
  };

  const handleChangeUserType = (event: any) => {
    setuserType(event.target.value);
  };

  const handleTestSMTP = async () => {
    setOpenSnackbar(false);

    const paylod = {
      host: host,
      port: port,
      username: username,
      password: password,
      clientid: clientId,
    };

    setRequestType("test");
    setLoader(true);

    const promises: any[] = [testSMTP(paylod)]; // Ensure that promises is an array

    if (isAuthUser === true) {
      try {
        const result: any = await Promise.all(promises);

        if (result[0].data.success) {
          setOpenSnackbar(true);
          setAlertType("success");
          setLoader(false);
          setAlertText(JSON.stringify(result[0].data.message));
        } else {
          setLoader(false);
          setOpenSnackbar(true);
          setAlertType("error");

          let isLoginFailed = result[0].data.error.includes("Invalid login");

          if (isLoginFailed) {
            setAlertText(i18n(lang).smtp_login_failed);
          } else {
            setAlertText(JSON.stringify(result[0].data.message));
          }

        }

      
      } catch (error) {
        setLoader(false);
        setOpenSnackbar(true);
        setAlertType("error");
        setAlertText(JSON.stringify(error));
        console.error("Error during Promise.all:", error);
        // Handle the error appropriately
      }
    }
  };
  const handleUpdateEmailConfig = async () => {
  
    if (host === "") {
      return;
    }

    const paylod = {
      clientid: clientId,
      clientinfo: {
        autoemailconfig: {
          host: host,
          port: port,
          from: from,
          username: username,
          password: password,
        },
      },
    };

    setRequestType("save");
    setLoader(true);

    const promises: any[] = [updateEmailConfig(paylod)]; // Ensure that promises is an array

    if (isAuthUser === true) {
      try {
        const result = await Promise.all(promises);
        setAlertText(i18n(lang).email_config_updated_success);
        setLoader(false);

      } catch (error) {
       
        setLoader(false);
        setAlertText(i18n(lang).email_config_updated_error);
        console.error("Error during Promise.all:", error);
        // Handle the error appropriately
      }
    }
  };

  const handleGenerateNetConnectConfig = async () => {
   

    if (isAuthUser === true) {
      try {
        const result = await getNetConnectConfiguration(
          legalEntityNodeId,
          lang
        );

        const blob = new Blob([JSON.stringify(result)], { type: "plain/text" });

        saveAs(blob, "NetConnectConfiguration.json");

        a11yProps(0);
        setAppBarValue(0);
      } catch (error) {
        console.error("Error during Promise.all:", error);
        // Handle the error appropriately
      }
    }
  };

  const acl_users: any = useBoundStore((state) => state.acl_users);

  useEffect(() => {
    if (users.length && acl_users.length) {
      const temp2: any[] = [];

      for (const usr of users) {
        let usertype = acl_users.length
          ? acl_users.filter(
              (user: any) => user.user.usernodeid === usr.user.nodeid
            )[0]?.user.userinfo.profileid
          : undefined;
        if (usertype !== undefined) {
          temp2.push({
            ...usr,
            userType: usertype,
          });
        }
      }

      set_users(temp2);
    }
  }, [users, acl_users]);

  useEffect(() => {
    if (users.length) {
      setData([]);
      let data: any = _users;

      if (searchEnabled) {
        if (searchText.length) {
          setPage(0);
          data = data.filter((row: any) => {
            return (
              row.user.givenname.toLowerCase().includes(searchText) ||
              row.user.surname.toLowerCase()?.includes(searchText) ||
              row.user.email.toLowerCase()?.includes(searchText)
            );
          });
        }
      }

      if (userStatus !== "alle") {
        data = data.filter((data: any) => {
          return data.user.active === Boolean(userStatus);
        });
      }

      if (userType !== "") {
        
        data = data.filter((data: any) => {
          return data.userType === userType;
        });
      }

      setData(data);
    }
  }, [searchText, userStatus, userType, _users]);

  useEffect(() => {
    if (!showFilter) {
      setStatusValue("alle");
      setuserType("");
    }
  }, [showFilter]);

  const [openSnackbar, setOpenSnackbar] = useState(false);

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertText("");
    setAlertType("");
    setOpenSnackbar(false);
  };

  return (
    <div className="admin_dashboard">
      <Snackbar
        className="bxShadow "
        open={openSnackbar}
        autoHideDuration={5000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        key={"top" + "right"}
      >
        {alertType === "success" ? (
          <Alert
            onClose={handleClose}
            icon={ <InfoCircle />}
            sx={{ width: "100%" }}
            style={{ width: "289px" }}
            severity="success"
          >
            {alertText}
          </Alert>
        ) : alertType === "error" ? (
          <Alert
            onClose={handleClose}
            icon={ <ErrorIcon />}
            sx={{ width: "100%" }}
            style={{ width: "289px" }}
            severity={ "error"}
          >
            {alertText}
          </Alert>) : <div></div>
}
      </Snackbar>

      <ScopeHeader
        bgColor="#B21412"
        bgImage="images/scope_header.png"
        txtColor="#FFFFFF"
        title={i18n(lang)?.admin_scope_header}
        description={i18n(lang)?.admin_scope_header_desc}
      />

      <Box sx={{ bgcolor: "background.paper" }}>
        <AppBar
          className="appBar"
          position="static"
          variant="elevation"
          sx={{ borderTopLeftRadius: "4px", borderTopRightRadius: "4px" }}
        >
          <Tabs
            value={appBarValue}
            onChange={(e: any, v: any) => handleAppBarChange(e, v)}
            indicatorColor="secondary"
            textColor="inherit"
            aria-label="full width tabs example"
          >
           
            <Tab className="tab" label={i18n(lang).user} {...a11yProps(0)} />
            <Tab className="tab" label={i18n(lang).eemail} {...a11yProps(1)} />
            <Tab className="tab" label={"netCONNECT"} {...a11yProps(1)} />
          </Tabs>
        </AppBar>

        <TabPanel value={appBarValue} index={0}>
          <div className="_content">
            <div className="header">
              <div
                className="_title"
                style={{ width: "35%", display: "flex", alignItems: "center" }}
              >
                <div>
                  {i18n(lang).user} ({_users.length})
                </div>
                <div className="_button">
                  <Link to={"/add-user"} state={{ padeType: "add" }}>
                    <Button variant="contained" sx={{ marginLeft: "20px" }}>
                      + {i18n(lang).new}
                    </Button>
                  </Link>
                </div>
              </div>

              <div className="_users_list" style={{ width: "35%" }}>
                {" "}
                <div>
                  <FormControl fullWidth variant="filled">
                    <FilledInput
                      sx={{ background: "#FFFFFF !important", paddingLeft: 0 }}
                      id="filled-adornment-weight"
                      placeholder={i18n(lang)?.admin_search_placeholder}
                      value={searchText}
                      onChange={handleSearch}
                      endAdornment={
                        <InputAdornment position="start">
                          <Search />
                        </InputAdornment>
                      }
                      aria-describedby="filled-weight-helper-text"
                      inputProps={{
                        "aria-label": "weight",
                      }}
                    />
                  </FormControl>
                </div>
              </div>
              <div
                style={{ width: "23%", display: "flex", justifyContent: "end" }}
              >
                <div className="_filterBtn">
                  <Button
                    variant={showFilter ? "outlined" : "text"}
                    startIcon={showFilter ? <CloseSvg /> : <Filter />}
                    onClick={() => {
                      setShowFilter(!showFilter);
                    }}
                  >
                    FILTER
                  </Button>
                </div>
              
              </div>
            </div>

            <Box
              sx={{ height: "auto", backgroundColor: "#2121210D" }}
              style={{ marginTop: showFilter ? "3%" : "0%" }}
            >
              <Box
                sx={{
                  "& > :not(style)": {
                    display: "flex",
                    justifyContent: "space-around",
                    height: "auto",
                    width: "100%",
                  },
                }}
              >
                <div>
                  <Collapse in={showFilter} sx={{ width: "100%" }}>
                    <div className="history-filters">
                      <div className="row1">
                        <div className="child">
                          <FormControl
                            variant="standard"
                            sx={{ margin: 0 }}
                            fullWidth
                          >
                            <InputLabel id={"filter_type"}>
                              {"User-Account-Status"}
                            </InputLabel>
                            <Select
                              labelId={"filter_type"}
                              id={"filter_type"}
                              label={i18n(lang).filter}
                              value={userStatus}
                              onChange={handleStatusChange}
                            >
                              <MenuItem value="alle">
                                <em>{i18n(lang).all}</em>
                              </MenuItem>
                              {[
                                {
                                  name: i18n(lang).active,
                                  value: 1,
                                },
                                {
                                  name: i18n(lang).inactive,
                                  value: 0,
                                },
                              ].map((noti, key) => {
                                return (
                                  <MenuItem value={noti.value} key={key}>
                                    {noti.name}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                        </div>

                        <div className="child">
                          <FormControl
                            variant="standard"
                            sx={{ margin: 0 }}
                            fullWidth
                          >
                            <InputLabel id={"filter_status"}>
                              {i18n(lang).user_type}
                            </InputLabel>
                            <Select
                              id={"filter_status"}
                              label={i18n(lang).filter}
                              value={userType}
                              onChange={handleChangeUserType}
                            >
                              {profiles &&
                                profiles?.map((profile: any) => {
                                  return (
                                    <MenuItem value={profile.id}>
                                      {profile?.name[lang]}
                                    </MenuItem>
                                  );
                                })}
                            </Select>
                          </FormControl>
                        </div>
                      </div>
                    </div>
                  </Collapse>
                </div>
              </Box>
            </Box>

            <UsersTable
              data={data}
              handlePageChange={handleChangePage}
              searchText={searchText}
              page={page}
              setPage={setPage}
              viewMode={viewMode}
            />
          </div>
        </TabPanel>

        <TabPanel value={appBarValue} index={1}>
          <div className="_content">
            <div className="header">
              <div
                className="_title"
                style={{ width: "35%", display: "flex", alignItems: "center" }}
              >
                <div>{i18n(lang)?.email_setting_title}</div>
              </div>
            </div>
            <div className="userPage">
              <section>
                <Paper sx={{ boxShadow: "none" }}>
                  <form style={{ padding: "24px 0px 0px 0px" }}>
                    <Grid
                      container
                      spacing={3}
                      direction="row"
                      justifyContent="space-between"
                    >
                      <Grid item xs={9}>
                        <Grid item xs={12}>
                          <Grid
                            container
                            spacing={3}
                            sx={{ paddingBottom: "24px" }}
                          >
                            <Grid item xs={12}>
                              <TextField
                                onChange={(e: any) => setHost(e.target.value)}
                                fullWidth
                                value={host}
                                label={"SMTP Host"}
                                variant="outlined"
                                required
                              />
                            </Grid>
                            <Grid item xs={12}>
                              <TextField
                                onChange={(e: any) => setPort(e.target.value)}
                                fullWidth
                                value={port}
                                label={"Port"}
                                variant="outlined"
                              />
                            </Grid>
                            <Grid item xs={12}>
                              <TextField
                                onChange={(e: any) => setFrom(e.target.value)}
                                fullWidth
                                value={from}
                                label={i18n(lang).from}
                                variant="outlined"
                              />
                            </Grid>
                            <Grid item xs={12}>
                              <TextField
                                onChange={(e: any) =>
                                  setUserName(e.target.value)
                                }
                                fullWidth
                                value={username}
                                label={i18n(lang).username}
                                variant="outlined"
                              />
                            </Grid>

                            <Grid item xs={12}>
                              <TextField
                                onChange={(e: any) =>
                                  setPassword(e.target.value)
                                }
                                fullWidth
                                value={password}
                                label={i18n(lang).password}
                                variant="outlined"
                                type="password"
                              />
                            </Grid>

                            <Grid item xs={12}>
                              <Button
                                variant="contained"
                                className="saveProfile"
                                sx={{
                                  backgroundColor: "var(--primary-color)",
                                  margin: "15px 0px",
                                }}
                                onClick={() => handleUpdateEmailConfig()}
                                disabled={
                                  host === "" ||
                                  (loader && requestType === "save")
                                }
                              >
                                {loader && requestType === "save" ? (
                                  <CircularProgress
                                    size={20}
                                    sx={{ marginRight: "5px" }}
                                  />
                                ) : (
                                  ""
                                )}{" "}
                                {i18n(lang)?.save}
                              </Button>

                              <Button
                                variant="contained"
                                className="saveProfile"
                                sx={{
                                  backgroundColor: "var(--primary-color)",
                                  margin: "0px 0px 0px 15px",
                                }}
                                disabled={
                                  host === "" ||
                                  (loader && requestType === "test")
                                }
                                onClick={() => handleTestSMTP()}
                              >
                                {loader && requestType === "test" ? (
                                  <CircularProgress
                                    size={20}
                                    sx={{ marginRight: "5px" }}
                                  />
                                ) : (
                                  ""
                                )}{" "}
                                {i18n(lang).test_smtp}
                              </Button>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>

                      <br />
                      <br />
                    </Grid>
                  </form>
                </Paper>
              </section>
            </div>
          </div>
        </TabPanel>

        <TabPanel value={appBarValue} index={2}>
          <div className="_content">
            <div style={{ textAlign: "center", padding: "10% 0% 10% 0%" }}>
              <Button
                variant="contained"
                onClick={() => handleGenerateNetConnectConfig()}
              >
                {" "}
                {i18n(lang).generate_configuration}
              </Button>
            </div>
          </div>
        </TabPanel>

        {/*  */}
      </Box>
    </div>
  );
}

export default Users;
